// 设备显示名 fallback：name 优先，空时用 SN 后 6 位（更可读），都没有则用 #device_id
export interface DeviceWithLabel {
	device_id: number | string;
	sn?: string;
	name?: string;
}

export function deviceLabel(d: DeviceWithLabel): string {
	if (d.name && d.name.trim()) return d.name;
	if (d.sn && d.sn.length >= 6) return `…${d.sn.slice(-6)}`;
	return `#${d.device_id}`;
}
